// Token utilities for Ionic Capacitor app
// Uses Ionic Storage on device/web (IndexedDB/localForage) and falls back to localStorage

export const TOKEN_KEYS = {
  ACCESS: "token",
  REFRESH: "refreshToken",
};

let storageInstance = null;
const getIonicStorage = async () => {
  if (storageInstance) return storageInstance;
  try {
    const { Storage } = await import('@ionic/storage');
    const storage = new Storage();
    await storage.create();
    storageInstance = storage;
    return storageInstance;
  } catch (e) {
    return null;
  }
}

export const CustomLocalStorage = {
  async getItem(key) {
    const storage = await getIonicStorage();
    if (storage) {
      try {
        const value = await storage.get(key);
        return value || null;
      } catch (e) {}
    }
    try {
      const value = localStorage.getItem(key);
      return value;
    } catch (e) {
      return null;
    }
  },
  async setItem(key, value) {
    const storage = await getIonicStorage();
    if (storage) {
      try {
        await storage.set(key, value);
        return;
      } catch (e) {}
    }
    try {
      localStorage.setItem(key, value);
    } catch (e) {}
  },
  async removeItem(key) {
    const storage = await getIonicStorage();
    if (storage) {
      try {
        await storage.remove(key);
        return;
      } catch (e) {}
    }
    try {
      localStorage.removeItem(key);
    } catch (e) {}
  },
};

export const isTokenExpired = (jwtToken) => {
  if (!jwtToken || typeof jwtToken !== "string") return true;
  const parts = jwtToken.split(".");
  if (parts.length !== 3) return true;
  try {
    const payloadJson = atob(parts[1]);
    const payload = JSON.parse(payloadJson) || {};
    if (!payload || !payload.exp) return true;
    const expiresAtMs = Number(payload.exp) * 1000;
    return Date.now() >= expiresAtMs - 5000;
  } catch (e) {
    return true;
  }
};

export const getAccessToken = () => CustomLocalStorage.getItem(TOKEN_KEYS.ACCESS);
export const getRefreshToken = () => CustomLocalStorage.getItem(TOKEN_KEYS.REFRESH);
export const setTokens = async (accessToken, refreshToken) => {
  if (accessToken) await CustomLocalStorage.setItem(TOKEN_KEYS.ACCESS, accessToken);
  if (refreshToken) await CustomLocalStorage.setItem(TOKEN_KEYS.REFRESH, refreshToken);
};
export const clearTokens = async () => {
  await CustomLocalStorage.removeItem(TOKEN_KEYS.ACCESS);
  await CustomLocalStorage.removeItem(TOKEN_KEYS.REFRESH);
};


